<template>
  <div class="c-app">
    <Sidebar/>
    <CWrapper>
      <Header/>
      <div class="c-body">
        <main class="c-main">
          <transition name="fade" mode="out-in">
            <Carousel v-if="$route.path === '/'"/>
          </transition>
          <CContainer fluid>  
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <Footer/>
    </CWrapper>
  </div>
</template>

<script>
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'
import Carousel from './Carousel'

export default {
  name: 'Container',
  components: {
    Sidebar,
    Header,
    Footer,
    Carousel,
  },
  async mounted () {
    this.$store.commit('set', ['sidebarShow', false]) // Always hide the sidebar on first load of the container (for mobile view)
  }
}
</script>

<style scoped>
.c-main {
  padding-top: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
